module.exports = {"title":"Category","create_category":"Create Category","update_category":"Update Category","assigned_product_category_will_be_overwritten_by_current_selected_category":"Assigned product category\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twill be overwritten by current\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tselected category","category_list":"Category List","type_to_search_or_create_category":"Type to search or create category","add_this_as_new_category":"Add this as new category","create_new_category":"Create new category"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/category.php
// module id = OUDI
// module chunks = 113